import {
  useEmailCreationFormInitialValues,
  useEmailGetActiveAccountForCreate,
} from '../../../../../Email'
import { useDocFlowSendingContext } from '../../../../DocFlow.hooks'
import { getDocFlowSendingEmailContentInitialValues } from '../../DocFlowSendingEmailContent.utils'

export function useDocFlowEmailFormValues() {
  const { processData } = useDocFlowSendingContext()

  const { activeAccountForCreate, loadingAccount } =
    useEmailGetActiveAccountForCreate()

  const docFlowInitialValues =
    getDocFlowSendingEmailContentInitialValues(processData)

  const initialValues = useEmailCreationFormInitialValues({
    account: loadingAccount
      ? undefined
      : processData?.email_account || activeAccountForCreate,
    initialValues: docFlowInitialValues,
  })

  return {
    initialValues,
  }
}
